import * as React from 'react';
import { PROFESSOR_STORE, MonografiaModel } from '../../../Store';
import {
  CardTitle,
  Input,
  CardContent,
  Card,
  withGrid
} from '../../../Components';
import styled from 'styled-components';
import { media } from '../../../Themes';
import { format } from 'date-fns';

/*
  interfaces
*/
interface IProps {
  monografia: MonografiaModel;

}

/*
  styled components
*/
const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;
const Grid = withGrid(CardContent);

const DetalhesBancaContent = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
  justify-content: none;
`;

/*
  Component: DetalhesBanca
*/
export class DetalhesBanca extends React.Component<IProps> {
  responderConvite = async (monografiaId: number, resposta: boolean) => {
    const store = this.props[PROFESSOR_STORE];

    await store
      .responderConvite(monografiaId, resposta)
      .then(() => store.recuperarInformacoesConvite());
  };

  render() {
    const { monografia } = this.props;
    return (
      monografia && (
        <Card>
          <CardTitle>Detalhes TCC</CardTitle>
          <DetalhesBancaContent>
            <InputGrid
              gridColumn='1/2'
              disabled={true}
              label={'Matrícula'}
              value={monografia.aluno.matricula}
            />
            <InputGrid
              gridColumn='2/14'
              disabled={true}
              label={'Nome do aluno'}
              value={monografia.aluno.nome}
            />
            <InputGrid
              gridColumn='1/14'
              disabled={true}
              label={'Orientador'}
              value={monografia.professor.nome}
            />
            {monografia.banca.filter((m, i) => m.conviteAceito != undefined).map((m, i) =>
              <InputGrid
                key={i}
                gridColumn='1/14'
                disabled={true}
                label={`Membro da banca ${i + 1}`}
                value={m.membro.nome}
              />
            )}
            <InputGrid
              gridColumn='1/14'
              disabled={true}
              label={'Titulo'}
              value={monografia.titulo}
            />
            <InputGrid
              gridColumn='1/14'
              disabled={true}
              label={'Data do depósito'}
              value={format(
                monografia.deposito!.dataDoDeposito,
                'DD/MM/YYYY HH:mm'
              )}
            />
          </DetalhesBancaContent>
        </Card>
      )
    );
  }
}
